module.exports = __webpack_public_path__ + "img/apidays-2021-snapshot-5.480ae684.jpg";